import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useStorageViewModel } from '../ViewModel/StorageViewModel';

export const StorageListView: React.FC = () => {
  const { buckets, isLoading, fetchBuckets } = useStorageViewModel();

  useEffect(() => {
    fetchBuckets();
  }, [fetchBuckets]);

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Storage Buckets</h1>
        <button className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
          + New Bucket
        </button>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          {isLoading ? (
            <div className="flex justify-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            </div>
          ) : (
            <table className="min-w-full">
              <thead>
                <tr className="text-left text-sm text-gray-500">
                  <th className="px-6 py-3">BUCKET NAME</th>
                  <th className="px-6 py-3">CREATED ON</th>
                  <th className="px-6 py-3">FILES</th>
                  <th className="px-6 py-3">SIZE</th>
                  <th className="px-6 py-3">ACTIONS</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {buckets.map((bucket) => (
                  <tr key={bucket.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <Link
                        to={`/storage/${bucket.id}`}
                        className="text-blue-500 hover:text-blue-600"
                      >
                        {bucket.name}
                      </Link>
                    </td>
                    <td className="px-6 py-4 text-gray-500">
                      {new Date(bucket.createdAt).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4 text-gray-500">
                      {bucket.fileCount}
                    </td>
                    <td className="px-6 py-4 text-gray-500">
                      {(bucket.size / 1024 / 1024).toFixed(2)} MB
                    </td>
                    <td className="px-6 py-4">
                      <button className="text-gray-600 hover:text-red-600">
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};